import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from 'api';

export const unflatWorkingLocations = {
  SEM: ['andorra', 'italy', 'morocco', 'portugal', 'spain'],
  RO: [
    'austria',
    'bulgaria',
    'croatia',
    'greece',
    'hungary',
    'moldova',
    'romania',
    'serbia',
    'slovenia',
    'turkey',
  ],
  PL: [
    'czech-republic',
    'denmark',
    'estonia',
    'finland',
    'germany',
    'latvia',
    'liechtenstein',
    'lithuania',
    'norway',
    'poland',
    'slovakia',
    'sweden',
    'switzerland',
    'ukraine',
  ],
  FR: [
    'belgium',
    'france',
    'ireland',
    'luxembourg',
    'monaco',
    'netherlands',
    'united-kingdom',
  ],
};

export const useSignUpForm = () => {
  const [workingLocations, setWorkingLocations] = useState([]);

  const { t } = useTranslation('SignUp');

  useEffect(() => {
    const fetchWorkingLocations = async () => {
      try {
        const flatWorkingLocations = [];

        const { results } = await api.getWorkingLocations();

        for (const result of results) {
          if (unflatWorkingLocations[result.slug]) {
            for (const unflatWorkingLocation of unflatWorkingLocations[
              result.slug
            ]) {
              flatWorkingLocations.push({
                value: unflatWorkingLocation,
                label: t(
                  `SignUpForm.working_locations.${unflatWorkingLocation}`
                ),
              });
            }
          } else {
            flatWorkingLocations.push(result);
          }
        }

        flatWorkingLocations.sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }

          if (a.label > b.label) {
            return 1;
          }

          return 0;
        });

        setWorkingLocations(flatWorkingLocations);
      } catch (error) {
        console.error(error);
      }
    };

    fetchWorkingLocations();
  }, [setWorkingLocations, t]);

  return {
    workingLocations,
  };
};
